// extracted by mini-css-extract-plugin
module.exports = {"row":"NewKeyword_row__Gt8cJ","col":"NewKeyword_col__VF2af","card":"NewKeyword_card__1Kc5q"};